<template>
  <div class="p-6">
    <formulate-form name="dataform" @submit="formHandler" class="grid gap-4">
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Nombre</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Nombre"
            help="Nombre del rol"
            class="md:w-7/12 w-full"
            v-model="name"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Tag</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <formulate-input
            type="text"
            name="Tag"
            help="Tag del rol"
            class="md:w-7/12 w-full"
            v-model="guard_name"
            validation="required"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col sm:w-1/6">
          <span>Menus</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full mb-6">
          <v-select
            multiple
            class="style-chooser md:w-7/12 w-full"
            :options="menus"
            label="men_name"
            v-model="rols"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/6">
          <span>Estado</span>
        </div>
        <div class="vx-col sm:w-5/6 w-full">
          <vs-switch
            color="dark"
            icon-pack="feather"
            vs-icon-on="icon-check-circle"
            vs-icon-off="icon-slash"
            v-model="rol_status"
          >
            <span slot="on">Activo</span>
            <span slot="off">Inactivo</span>
          </vs-switch>
        </div>
      </div>
      <div class="vx-row flex justify-center">
        <div class="vx-col md:w-1/3 w-full grid grid-cols-2 gap-4">
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-save"
            @click="saveform"
            ref="loadableButton"
            id="button-with-loading"
            class="vs-con-loading__container"
            >Grabar</vs-button
          >
          <vs-button
            color="#EE9436"
            icon-pack="feather"
            icon="icon-arrow-left"
            @click="go_back"
            >Regresar</vs-button
          >
        </div>
      </div>
    </formulate-form>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {
    menus() {
      return this.$store.state.lists.table_menu;
    },
    name: {
      get() {
        return this.$store.state.rol.name || null;
      },
      set(val) {
        this.$store.commit("rol/name", val);
      },
    },
    guard_name: {
      get() {
        return this.$store.state.rol.guard_name || null;
      },
      set(val) {
        this.$store.commit("rol/guard_name", val);
      },
    },
    rol_status: {
      get() {
        return this.$store.state.rol.rol_status || null;
      },
      set(val) {
        val = val == true ? 1 : 0;
        this.$store.commit("rol/rol_status", val);
      },
    },
    rols: {
      get() {
        return this.$store.state.rol.rols || null;
      },
      set(val) {
        this.$store.commit("rol/rols", val);
      },
    },
  },

  methods: {
    go_back() {
      let display = {
        table: true,
        add: false,
        edit: false,
      };
      this.$emit("screen", display);
    },
    saveform() {
      this.$formulate.submit("dataform");
    },
    async formHandler() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#button-with-loading",
        scale: 0.45,
      });
      try {
        await this.$store.dispatch("rol/setRol", this.$store.state.rol);
        this.$vs.notify({
          title: "Success",
          text: "Guardado",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
        });
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
        let display = {
          table: true,
          add: false,
          edit: false,
        };
        this.$emit("screen", display);
      } catch (error) {
        this.$vs.loading.close("#button-with-loading > .con-vs-loading");
      }
    },
  },
};
</script>
